import { motion } from "framer-motion";
import { Mail, Phone, MessageCircle, MapPin } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { CONTACT } from "@/i18n/translations";

export const ContactStrip = () => {
  const { t } = useLanguage();
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.whatsapp.message)}`;

  return (
    <section id="contact" className="relative py-24 lg:py-28 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="border border-[rgba(20,112,63,0.16)] rounded-sm bg-[#F8FBF8] p-8 lg:p-12 flex flex-col lg:flex-row lg:items-center gap-10"
        >
          <div className="flex-1">
            <span className="eyebrow-label">{t.mini.contactEyebrow}</span>
            <h2 className="font-serif-display text-3xl sm:text-4xl tracking-tight mt-3 text-[#12261A]">
              {t.mini.contactTitle} — <span className="italic text-[#14703F]">{t.contact.person}</span>
            </h2>
            <div className="mt-5 flex items-center gap-2 text-sm text-[#51685A]">
              <MapPin size={14} className="text-[#14703F]" />
              {t.contact.corridorsValue}
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:w-80" data-testid="contact-details">
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              data-testid="contact-phone"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#14703F] text-white px-6 py-4 font-mono-spec text-[11px] tracking-[0.18em] uppercase font-semibold hover:bg-[#0E5A32] transition-colors duration-300"
            >
              <Phone size={14} />
              {CONTACT.phoneDisplay}
            </a>
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[rgba(20,112,63,0.4)] text-[#14703F] px-6 py-4 font-mono-spec text-[11px] tracking-[0.18em] uppercase hover:bg-[rgba(20,112,63,0.07)] transition-colors duration-300"
            >
              <MessageCircle size={14} />
              {t.mini.whatsapp}
            </a>
            <a
              href={`mailto:${CONTACT.email}?subject=Veneer%20Enquiry%20—%20Aaravya%20Impex`}
              data-testid="contact-mailto-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[rgba(20,112,63,0.4)] text-[#14703F] px-6 py-4 font-mono-spec text-[11px] tracking-[0.18em] uppercase hover:bg-[rgba(20,112,63,0.07)] transition-colors duration-300"
            >
              <Mail size={14} />
              {CONTACT.email}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
